<template>
    <div class="row">
        <div class="col-sm-4 col-md-4 col-lg-3 col-xl-3 mb-primary" v-if="data.length > 0"
             v-for="(profile, rowIndex) in data" :key="'row'+rowIndex">
            <documentlibrary-mydocument-card
                :id="profile.get_forms.id"
                :profile="profile.get_forms"
                :actions="actions"
                @action-grid-view-table="getAction"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "ResponseGridView",
    props: ['id', 'data', 'actions'],
    methods: {
        getAction(row, action, active) {
            this.$emit('action', row, action, active);
        }
    }
}
</script>
